import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import demandInfo from './demand-info.vue';
import taskTable from './task-table.vue';
import taskForm from './task-form.vue';
import toTestForm from './to-test-form';
import updateForm from './update-form';
import ActionBar from '../components/action-bar.vue';
import _ from 'lodash';
import { fetchDeliverInfo, fetchTmplDeliverInfo, updateInteractiveTask, toTestInteractiveTask, deleteInteractiveTask, submitDeliverInfo } from '@/api/demand/interactive';
import { materialSourceType } from '@/common/material-metadata';
import { fecthBasicInfo } from '@/api/material/basic';
import { batchRequest } from '../utils/batchProcessing';

export default {
  components: {
    demandInfo: demandInfo,
    taskTable: taskTable,
    taskForm: taskForm,
    ActionBar: ActionBar,
    toTestForm: toTestForm,
    updateForm: updateForm
  },
  watch: {
    'formValue.basic_id': function formValueBasic_id(val) {
      if (val) {
        this.getBasicInfo(val);
      }
    },
    'formValue.choose_base': function formValueChoose_base(val) {
      if (val === 1) {
        this.formValue.basic_id = '';
      }
    },
    taskActionType: function taskActionType(val) {
      this.$refs['task-table'].clearSelection();
      this.setSubmitText();
    }
  },
  data: function data() {
    return {
      loading: true,
      loadingProgress: 0,
      showLoadingProgress: false,
      demand: {},
      tasks: [],
      selectTasks: [],
      columnConfig: ['selection', 'platform', 'creation_types', 'channels', 'orientation', 'logo_position', 'close_time', 'category_id', 'basic_id', 'submit_task_id', 'status'],
      taskActionType: 1,
      taskActionTypeOptions: [{
        label: '提交',
        value: 1
      }, {
        label: '更新',
        value: 2
      }, {
        label: '提测',
        value: 3
      }, {
        label: '删除',
        value: 4
      }],
      formValue: {
        choose_base: 0,
        basic_id: '',
        basic_file: '',
        render_type: 1,
        is_compress: 3,
        tag_ids: [],
        is_self_test: 1,
        tester_id: null,
        priority: 2,
        stage: [],
        isSupportStage: '',
        source_type: '',
        source_id: '',
        source_type_text: ''
      },
      updateValue: {
        basic_file: '',
        is_compress: 3,
        comment: ''
      },
      toTestValue: {
        tester_id: null
      },
      submitButtonParams: {
        loading: false,
        text: '提交'
      }
    };
  },

  methods: {
    getDeliverInfo: function getDeliverInfo(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                res = void 0;
                // 如果是模版制作中提测

                if (!(_this.formValue.source_type === 3)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return fetchTmplDeliverInfo({
                  id: id
                });

              case 6:
                res = _context.sent;
                _context.next = 12;
                break;

              case 9:
                _context.next = 11;
                return fetchDeliverInfo({
                  id: id
                });

              case 11:
                res = _context.sent;

              case 12:
                _this.loading = false;
                _this.demand = _.get(res, 'data.data.demand');
                // 把所有status>0的任务放在前面
                _this.tasks = (_.get(res, 'data.data.tasks') || []).sort(function (a, b) {
                  if (a.status === 0 && b.status !== 0) {
                    return -1;
                  }
                  if (a.status !== 0 && b.status === 0) {
                    return 1;
                  }
                  return 0;
                });
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](1);

                _this.loading = false;
                console.log(_context.t0);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 17]]);
      }))();
    },
    getBasicInfo: function getBasicInfo(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, info, setting;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!id) true;
                _context2.prev = 1;
                _context2.next = 4;
                return fecthBasicInfo({
                  id: id
                });

              case 4:
                res = _context2.sent;
                info = _.get(res, 'data.data.info');
                setting = info.setting ? JSON.parse(info.setting) : '';

                _this2.formValue.tag_ids = info.tag_ids ? info.tag_ids.split(',') : [];
                _this2.formValue.render_type = info.render_type ? info.render_type : 1;
                if (setting && setting.stage) {
                  _this2.formValue.isSupportStage = 1;
                  _this2.formValue.stage = setting.stage.split(',');
                } else {
                  _this2.formValue.isSupportStage = 0;
                }
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 12]]);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(row) {
      this.selectTasks = row;
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.selectTasks.length) {
        this.$message({
          message: '请勾选选择的任务',
          type: 'warning'
        });
        return;
      }
      // 提交流程
      if (this.taskActionType === 1) {
        if (!this.checkIsSameCategory()) {
          this.$message({
            message: '请勾选相同素材类型的任务',
            type: 'warning'
          });
          return;
        }
        this.$refs['form'].validate().then(function (res) {
          _this3.submitDeliverTask();
        }).catch(function (res) {
          console.log(res);
        });
      }
      // 更新
      if (this.taskActionType === 2) {
        if (this.$refs['update-form'].validate()) {
          this.submitUpdateTask();
        }
      }
      // 提测流程
      if (this.taskActionType === 3) {
        if (this.$refs['to-test-form'].validate()) {
          this.submitToTestTask();
        }
      }
      // 删除
      if (this.taskActionType === 4) {
        this.submitDeleteTask();
      }
    },
    checkIsSameCategory: function checkIsSameCategory() {
      var categoryId = this.selectTasks[0].category_id;
      return this.selectTasks.findIndex(function (item) {
        return item.category_id !== categoryId;
      }) === -1;
    },
    cookPostData: function cookPostData() {
      var postData = _.cloneDeep(this.formValue);
      postData.demand_id = this.demand.id;
      postData.task_ids = this.selectTasks.map(function (e) {
        return e.id;
      }).join();
      // 选择已有基础包和重新上传支持包的上传字段不一样
      if (postData.choose_base === 1) {
        postData = _.omit(postData, ['choose_base', 'basic_file', 'render_type', 'tag_ids', 'source_type', 'source_id']);
      } else {
        postData = _.omit(postData, ['choose_base', 'basic_id']);
      }
      if (postData.is_self_test === 1) {
        postData.tester_id = 0;
      } else {
        postData.tester_id = Number(postData.tester_id);
      }
      // 如果不存在source_id则删除对应字段，如果存在。则删除basic_file
      if (!postData.source_id) {
        postData = _.omit(postData, ['source_id', 'source_type']);
      } else {
        postData = _.omit(postData, ['basic_file']);
        // 如果是模版提测，去除渲染模式和基础包标签选项，并且赋值demand.basic_id到postData.basic_id中
        if (postData.source_type === 3) {
          postData = _.omit(postData, ['render_type', 'tag_ids']);
          postData.basic_id = this.demand.basic_id;
        }
      }
      postData = _.omit(postData, ['is_self_test', 'source_type_text']);
      // 如果选择category不是1, 2、3的话，删除is_compress字段
      var canCompress = [1, 2, 3];
      if (canCompress.indexOf(this.selectTasks[0].category_id) === -1) {
        postData = _.omit(postData, ['is_compress']);
      }
      return postData;
    },
    submitToTestTask: function submitToTestTask() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var postData, res, errorMsg;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.submitButtonParams.loading = true;
                postData = {
                  ids: _this4.selectTasks.map(function (item) {
                    return item.id;
                  }).join(','),
                  tester_uid: Number(_this4.toTestValue.tester_id)
                };
                _context3.prev = 2;
                _context3.next = 5;
                return toTestInteractiveTask(postData);

              case 5:
                res = _context3.sent;

                if (_.get(res, 'data.code') === 0) {
                  _this4.$message({
                    message: '提测成功',
                    type: 'success'
                  });
                  _this4.$router.go(0);
                }
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](2);
                errorMsg = _.get(_context3.t0, 'data.msg');

                _this4.$alert(errorMsg, '错误提示', {
                  type: 'error',
                  customClass: 'basic-package-error-message',
                  dangerouslyUseHTMLString: true
                });

              case 13:
                _this4.submitButtonParams.loading = false;

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[2, 9]]);
      }))();
    },
    submitDeleteTask: function submitDeleteTask() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var postData, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.submitButtonParams.loading = true;
                postData = {
                  ids: _this5.selectTasks.map(function (item) {
                    return item.id;
                  }).join(',')
                };
                _context4.prev = 2;
                _context4.next = 5;
                return deleteInteractiveTask(postData);

              case 5:
                res = _context4.sent;

                if (_.get(res, 'data.code') === 0) {
                  _this5.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  _this5.$router.go(0);
                }
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](2);

                console.log(_context4.t0);

              case 12:
                _this5.submitButtonParams.loading = false;

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[2, 9]]);
      }))();
    },
    submitDeliverTask: function submitDeliverTask() {
      var _this6 = this;

      this.submitButtonParams.loading = true;
      this.loading = true;
      this.showLoadingProgress = true;
      var postData = this.cookPostData();

      // 使用 batchRequest 工具函数
      batchRequest(postData, 'task_ids', function (data) {
        // 实际发送请求的函数
        return submitDeliverInfo(data);
      }, 5, // 每批 5 个任务
      function (progress) {
        _this6.loadingProgress = progress;
      }).then(function () {
        _this6.submitButtonParams.loading = false;
        _this6.loading = false;
        _this6.showLoadingProgress = false;
        _this6.$message({
          message: '提交成功',
          type: 'success'
        });
        _this6.$router.go(-1);
      }).catch(function (error) {
        var errorMsg = _.get(error, 'data.msg');
        _this6.$alert(errorMsg, '错误提示', {
          type: 'error',
          customClass: 'basic-package-error-message',
          dangerouslyUseHTMLString: true
        });

        _this6.submitButtonParams.loading = false;
        _this6.loading = false;
        _this6.showLoadingProgress = false;
      });
    },
    submitUpdateTask: function submitUpdateTask() {
      var _this7 = this;

      this.submitButtonParams.loading = true;
      this.loading = true;
      this.showLoadingProgress = true;
      var postData = {
        ids: this.selectTasks.map(function (item) {
          return item.id;
        }).join(','),
        zip_file: this.updateValue.basic_file,
        is_compress: this.updateValue.is_compress,
        comment: this.updateValue.comment

        // 使用 batchRequest 工具函数
      };batchRequest(postData, 'ids', function (data) {
        // 实际发送请求的函数
        return updateInteractiveTask(data);
      }, 5, // 每批 5 个任务
      function (progress) {
        _this7.loadingProgress = progress;
      }).then(function () {
        _this7.submitButtonParams.loading = false;
        _this7.loading = false;
        _this7.showLoadingProgress = false;
        _this7.$message({
          message: '更新成功',
          type: 'success'
        });
        _this7.$router.go(-1);
      }).catch(function (error) {
        var errorMsg = _.get(error, 'data.msg');
        _this7.$alert(errorMsg, '错误提示', {
          type: 'error',
          customClass: 'basic-package-error-message',
          dangerouslyUseHTMLString: true
        });

        _this7.submitButtonParams.loading = false;
        _this7.loading = false;
        _this7.showLoadingProgress = false;
      });
    },
    fillSource: function fillSource() {
      var _this8 = this;

      // 如果存在source_id的query。说明该任务从在线制作/制作模版中跳转过来
      if (this.$route.query.source_id) {
        this.formValue.choose_base = 0;
        this.formValue.source_id = this.$route.query.source_id;
        this.formValue.source_type = Number(this.$route.query.source_type);
        var sourceTypeText = materialSourceType.find(function (e) {
          return e.value === Number(_this8.formValue.source_type);
        });
        this.formValue.source_type_text = sourceTypeText ? sourceTypeText.label : '-';
      }
    },
    setSubmitText: function setSubmitText() {
      var _this9 = this;

      this.submitButtonParams.text = this.taskActionTypeOptions.find(function (item) {
        return item.value === _this9.taskActionType;
      }).label;
    }
  },
  mounted: function mounted() {
    this.fillSource();
    this.getDeliverInfo(this.$route.params.id);
    this.setSubmitText();
  }
};